module.exports = __webpack_public_path__ + "img/Pranav.fd615aae.jpeg";